export default __webpack_public_path__ + "static/media/factory__4.310a9312.jpg";